import { useState } from "react";
import Button from "../../../components/common/button/Button";
import Input from "../../../components/common/input/Input";
import Textarea from "../../../components/common/textarea/Textarea";
import styles from "./Contact.module.scss";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import CommonService from "../../../api/services/common.service";
import { useTranslation } from "react-i18next";
import LinkedIn from "../../../assets/svgs/footer/LinkedIn";

const Contact = () => {
  const { t } = useTranslation("translation");
  const [addLoading, setAddLoading] = useState(false);
  const [values, setValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country: "",
    message: "",
  });
  const [status, setStatus] = useState<{
    type: "success" | "error";
    message: string;
  } | null>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    if (status) {
      setStatus(null);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(null);
    setAddLoading(true);
    try {
      const formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("country", values.country);
      formData.append("message", values.message);
      await CommonService.contact(formData);
      setStatus({ type: "success", message: t("contact_success") });
      // Reset form after successful submission
      setValues({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country: "",
        message: "",
      });
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("contact_error");
      setStatus({ type: "error", message });
    } finally {
      setAddLoading(false);
    }
  };
  return (
    <div className={styles.contact}>
      <TitleUpdater title={t("contact_title")} />
      <div className="container">
        <div className={styles.contactWrapper}>
          <div className={styles.formSection}>
            <div className={styles.head}>
              <h2 className={styles.title}>{t("contact_title")}</h2>
            </div>
            {status && (
              <div
                className={
                  status.type === "success"
                    ? styles.successMessage
                    : styles.errorMessage
                }
              >
                {status.message}
              </div>
            )}
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.inputs}>
                <Input
                  label={t("firstName") || "Ad, soyad"}
                  placeholder={
                    t("placeholders.firstName") || "Ad soyadınızı daxil edin"
                  }
                  name="first_name"
                  value={values.first_name}
                  onChange={handleChange}
                  className={styles.input}
                  required
                />
                <Input
                  label={(t("phone") || "Telefon") + " *"}
                  placeholder={
                    t("placeholders.phone") || "Telefon nömrənizi daxil edin"
                  }
                  name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  className={styles.input}
                  phone
                  required
                />
                <Input
                  label={(t("email") || "Email") + " *"}
                  placeholder={
                    t("placeholders.email") || "Emailinizi daxil edin"
                  }
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  className={styles.input}
                  required
                />
                <Input
                  label={(t("country") || "Ölkə") + " *"}
                  placeholder={
                    t("placeholders.country") || "Ölkənizi daxil edin"
                  }
                  name="country"
                  value={values.country}
                  onChange={handleChange}
                  className={styles.input}
                  required
                />
                <Textarea
                  label={(t("message") || "Mesaj") + " *"}
                  placeholder={
                    t("placeholders.message") || "Mesajınızı daxil edin"
                  }
                  name="message"
                  value={values.message}
                  onChange={handleChange}
                  className={styles.textarea}
                  required
                />
              </div>
              <div className={styles.submit}>
                <Button
                  type="submit"
                  disabled={addLoading}
                  loading={addLoading}
                >
                  {t("submit") || "Göndər"}
                </Button>
              </div>
            </form>
          </div>

          <div className={styles.infoSection}>
            <div className={styles.infoBlock}>
              <h3 className={styles.infoTitle}>{t("contact")}</h3>
              <div className={styles.infoItem}>
                <svg
                  className={styles.icon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 2C6.13 2 3 5.13 3 9c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                    fill="currentColor"
                  />
                </svg>
                <p>Xətai rayonu General Əliağa Şıxlinski küçəsi 555</p>
              </div>
              <div className={styles.infoItem}>
                <svg
                  className={styles.icon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M16.5 3h-13C2.67 3 2 3.67 2 4.5v11c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5zM10 10.75l-6.5-4V5l6.5 4 6.5-4v1.75l-6.5 4z"
                    fill="currentColor"
                  />
                </svg>
                <p>+994 70 566 65 50</p>
              </div>
            </div>

            <div className={styles.infoBlock}>
              <h3 className={styles.infoTitle}>{t("service_hours")}</h3>
              <div className={styles.infoItem}>
                <svg
                  className={styles.icon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 2C5.58 2 2 5.58 2 10s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm.5-10H9v5l4.25 2.52.75-1.23-3.5-2.08V6z"
                    fill="currentColor"
                  />
                </svg>
                <p>24/7</p>
              </div>
            </div>

            <div className={styles.infoBlock}>
              <h3 className={styles.infoTitle}>{t("follow_us")}</h3>
              <div className={styles.socialLinks}>
                <a
                  href="https://www.instagram.com/alievsspace/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/alievs-space-mmc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  <LinkedIn />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
